export const MEDIA_TYPE = {
  image: ["image/x-png", "image/gif", "image/jpeg", "image/jpg"],
  video: ["video/mp4", "video/mkv", "video/avi", "video/mov"]
};
